import { render, staticRenderFns } from "./goLive.vue?vue&type=template&id=3439f4be&scoped=true&"
import script from "./goLive.vue?vue&type=script&lang=js&"
export * from "./goLive.vue?vue&type=script&lang=js&"
import style0 from "./goLive.vue?vue&type=style&index=0&id=3439f4be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439f4be",
  null
  
)

export default component.exports